import React, { useState, useEffect } from "react";
import { Card, Button, Box, Stack, Typography } from "@mui/material";
import PDFViewerModal from "src/components/PDFViewerModal";
import { obtenerPdf } from "src/api/pdfService";
import { useAuth } from "../../../contexts/AuthContext"; 

export default function MantenimientosPorVencer() {
    const { user } = useAuth();
    const usuarioId = user?.idUsuario;
    const [pdfUrl, setPdfUrl] = useState<string | null>(null);

    const verReporte = async () => {
        if (!usuarioId) return;
        const blob = await obtenerPdf("/mantenimientosPorVencer/" + usuarioId);
        const url = URL.createObjectURL(blob);
        setPdfUrl(url);
    };

    useEffect(() => {
        let isMounted = true;

        const cargarReporte = async () => {
            if (!usuarioId) return;
            const blob = await obtenerPdf("/mantenimientosPorVencer/" + usuarioId);
            if (isMounted) {
                const url = URL.createObjectURL(blob);
                setPdfUrl(url);
            }
        };

        cargarReporte();

        return () => {
            isMounted = false;
        };
    }, [usuarioId]);

    return (
        <Box className="p-4">
            <Card sx={{ padding: 3 }}>
                <Stack 
                    direction="row" 
                    justifyContent="space-between" 
                    alignItems="center"
                    mb={2}
                >
                    <Typography variant="h6" fontWeight="600">
                        Reporte mantenimientos por vencer
                    </Typography>

                    <Button variant="contained" onClick={verReporte}>
                        Actualizar PDF
                    </Button>
                </Stack>

                <Typography color="text.secondary">
                    Este reporte muestra los vehículos con cambios por vencer.
                </Typography>
            </Card>

            <PDFViewerModal
                pdfUrl={pdfUrl}
                onClose={() => setPdfUrl(null)}
                title="Reporte de Mantenimientos por vencer"
            />
        </Box>
    );
}
